export class IResolver {}
